// extracted by mini-css-extract-plugin
export default {"tableOfContents":"TableOfContents_tableOfContents__7ZBTy","contentSection":"TableOfContents_contentSection__wPKuZ"};